import { Card, device, Main_Plain, Red_, Slider_ } from 'monica-alexandria'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { get_invoices } from '../../../../services/api/Mocks';
import styled from 'styled-components';
import { Invoice_Card } from '../../../partials/invoiceCard/Invoice_Card';




export const Lois_Subscriber_Invoices = (props) => {
    const {t} = useTranslation();
    const [invoices, setInvoices] = useState([]) 

    const getInvoices = (payload)=>{
        get_invoices(payload)
        .then(res =>{
            setInvoices(res?.data?.data)    
        }
    )}


    useEffect(() => {

      let payload = {
        userId:props.userId,
        customerId: props.selectedSub,
        category:'lois'
      };

      getInvoices(payload);
    }, []);
    console.log('invoices', invoices);
    

  return (
    <Slider_
        title={t("Invoices")} 
        //text={t("I wish to continue")} 
        //  icon="Next" 
        onClick={()=>props.setSelectedSub(false)}
        grey={t("Cancel")}
        icon="Check"
        iconGreyLeft="Xicon"
        onClose={()=>props.setSelectedSub(false)}
        onGrey={()=>props.setSelectedSub(false)}
        text={t("Done")}
    >
        {invoices?.map((invoice, i) => (
            <Invoice_Card
              amountPaid={invoice?.amountPaid /100}
          
            >
          <p>{t("Period")}:</p>
            <h5>{new Date(invoice?.start * 1000).toLocaleDateString('el-GR')} - {new Date(invoice?.end * 1000).toLocaleDateString('el-GR')}</h5>
            {invoice?.status ? 
              <>
                <p>{t("Status")}:</p>
                <h5>{invoice?.status}</h5>
              </>
            :null}
          </Invoice_Card>
          
        ))}
    </Slider_>
  )
}
